import React, { Component } from 'react';
import { connect } from 'react-redux';
import _isEqual from 'lodash/isEqual';

// import Tabs from '../../components/Tab';
import GeneralSetup from './GeneralSetup';
// import Description from './Description';
// import Branding from './Branding';
// import Security from './Security';
// import EmailConfiguration from './EmailConfiguration';
// import FooterConfig from './FooterConfig';
import { constructURL } from '../../common/utils';
import ExchangeTerminateMessage from '../../common/exchangeTerminate'
import { Wrapper } from './style';

// const TabData = (moveToTab = () => { }) => [
//     {
//         key: 'generalSetup',
//         name: 'General Setup',
//         content: <GeneralSetup />
//     },
// {
//     key: 'description',
//     name: 'Description',
//     content: <Description />
// },
// {
//     key: 'branding',
//     name: 'Branding',
//     content: <Branding />
// },
// {
//     key: 'security',
//     name: 'Security',
//     content: <Security />
// },
// {
//     key: 'emails',
//     name: 'Emails',
//     content: <EmailConfiguration />
// },
// {
//     key: 'footer',
//     name: 'Footer',
//     content: <FooterConfig moveToTab={moveToTab} />
// }
// ];

class General extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: '0',
            generalInitialValues: {}
        }
    }

    componentDidMount() {
        this.generateInitialValue();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_isEqual(prevProps.exchange, this.props.exchange)
            || !_isEqual(prevProps.biz, this.props.biz)
        ) {
            this.generateInitialValue();
        }
    }

    moveToTab = (key) => {
        this.setState({ activeTab: key });
    };

    handleChange = (tab) => {
        this.setState({ activeTab: tab });
    };

    generateInitialValue = () => {
        const { biz, exchange, history } = this.props;
        let country = exchange[0]
            && exchange[0].info
            && exchange[0].info.public.country
            ? exchange[0].info.public.country
            : exchange[0].info.biz.DEFAULT_COUNTRY;
        if (Object.keys(exchange).length === 0) {
            history.push('/');
        }

        const generalInitialValues = {
            EXCHANGE_NAME: biz.EXCHANGE_NAME,
            DEFAULT_COUNTRY: country,
            // DEFAULT_COUNTRY: biz.DEFAULT_COUNTRY || country,
            // TIME_ZONE: biz.TIME_ZONE,
            // LANGUAGE: biz.LANGUAGE,
            // id: biz.id,
            URL: constructURL(biz.URL),
            DOMAIN: constructURL(biz.DOMAIN),
            NAME: `${biz.NAME} - ${biz.id}`
        };
        this.setState({ generalInitialValues });
    };

    render() {
        return (
            <Wrapper>
                <div className="main-header">
                    General
                </div>
                {/* <Tabs
                    activeTab={this.state.activeTab}
                    TabList={TabData(this.moveToTab)}
                    onChange={this.handleChange}
                /> */}
                <div className="content">
                    <div className={`content-item ${this.props.constant.isExchangeExpired ? "expired-status" : ""}`}>
                        <GeneralSetup
                            history={this.props.history}
                            initialValues={this.state.generalInitialValues}
                        />
                    </div>
                    {this.props.constant.isExchangeExpired && <ExchangeTerminateMessage />}
                    {/*<div className="content-item">
                        <Description />
                    </div>
                    <div className="content-item">
                        <Branding />
                    </div>
                    <div className="content-item">
                        <Security />
                    </div>
                    <div className="content-item">
                        <EmailConfiguration />
                    </div>
                    <div className="content-item">
                        <FooterConfig moveToTab={this.moveToTab} />
                    </div>*/}
                </div>
            </Wrapper>
        )
    }
}

const mapStateToProps = (state) => ({
    exchange: state.exchange,
    biz: state.setup.biz,
    constant: state.constant,
});

export default connect(mapStateToProps)(General);
